import { S3_HOST } from '../enviroment';

export function getUrlFile(path) {
  if (!path) return '';
  return `${S3_HOST}/${path}`;
}
